<template>
  <el-dialog :close-on-click-modal="false"
             class="batsku--select__dialog"
             :visible.sync="show"
             width="700px"
             :title="$t('stores::products-info::edit_sku_title')">
    <el-row class="batsku--select__wrap">
      <el-col :span="4">
        <div class="batsku--select__setting">
          {{ $t('menu::stores::product-manager') }}
        </div>
      </el-col>
      <el-col :span="20">
        <el-select class="batsku--select__inner" style="width: 100%" v-model="selectedSpu" filterable>
          <el-option v-for="(item, index) in selection" :key="item.id" :value="index" :label="item.title"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-button class="batsku--select__leftRow" @click="pre" :disabled="selectedSpu === 0">
      <i class="iconfont icondown-circle-01"></i>
    </el-button>
    <el-form :model="selectList[selectedSpu]" ref="tableForm" class="batsku--select__form">
      <el-table :data="selectList[selectedSpu].skus" :height="350">
        <el-table-column label="SKU" prop="skuId" min-width="130">
          <template slot-scope="{ row }">
            <span>{{ row.skuId }}{{ row.optionValueNames ? '-' + row.optionValueNames : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('stores::products-info::use_stock')" prop="availableInventory"></el-table-column>
        <el-table-column :label="$t('stores::products-info::goods_stock')" prop="skuInventory"></el-table-column>
        <el-table-column prop="safeInventory">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model.trim="priceDialogHeader.safeInventory"
              @change="val => handlePriceChange(scope, val)"
              :placeholder="$t('stores::products-info::safe_stock')"
            />
          </template>
          <template slot-scope="{ row, $index }">
            <el-form-item :prop="`skus.${$index}.safeInventory`"
                          :key="$index"
                          :rules="[{
                            trigger: 'change',
                            validator: checkInputSafe}]">
              <el-input v-model="row.safeInventory" :placeholder="$t('system::common::input_holder')"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-button class="batsku--select__rightRow" @click="next" :disabled="selectedSpu === selectList.length - 1">
      <i class="iconfont icondown-circle-01"></i>
    </el-button>
    <div slot="footer" style="text-align: center">
      <el-button style="width: 72px;" size="small" @click="show = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button style="width: 72px;" size="small" type="primary" @click="confirm">{{ $t('system::common::btn::save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { batchSetSku } from '@/server/product';
import { deepClone } from '@/utils'

export default {
  name: 'BatchSetSku',
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      selectedSpu: 0,
      selectList: [{ skus: []}],
      priceDialogHeader: {
        safeInventory: ''
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.selectList = deepClone(this.selection)
        this.priceDialogHeader.safeInventory = ''
      }
    },
  },
  methods: {
    handlePriceChange (data, val) {
      const regEx = new RegExp(/^[0-9]*$/)
      if (val !== '') {
        if (regEx.test(val)) {
          this.selectList[this.selectedSpu].skus = this.selectList[this.selectedSpu].skus.map(item => {
            item[data.column.property] = val
            return {
              ...item
            }
          })
        } else {
          this.$message.error($t('system::common::input_number'))
          this.priceDialogHeader[data.column.property] = ''
        }
      }
    },
    checkInputSafe (rule, value, callback) {
      if (value === '' || value === null || !new RegExp(/^[0-9]*$/).test(value)) {
        callback(new Error())
      } else {
        callback()
      }
    },
    pre() {
      if (this.selectedSpu !== 0) {
        this.selectedSpu = this.selectedSpu - 1
        this.priceDialogHeader.safeInventory = ''
      }
    },
    next() {
      if (this.selectedSpu !== this.selectedSpu.length - 1) {
        this.selectedSpu = this.selectedSpu + 1
        this.priceDialogHeader.safeInventory = ''
      }
    },
    showDialog() {
      this.show = true;
    },
    async confirm() {
      this.$refs.tableForm.validate(async (valid) => {
        if (valid) {
          let postData = []
          this.selectList.forEach(item => {
            item.skus.forEach(i => {
              postData.push(i)
            })
          })
          postData = postData.map(item => {
            return {
              skuId: item.skuId,
              safeInventory: item.safeInventory || 0
            }
          })
          const { data } = await batchSetSku(
            postData
          )
          if (data.code === this.$code) {
            this.$message.success($t('system::tip::control_success'))
            this.show = false
            this.selectedSpu = 0
            this.$emit('success')
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
 .batsku--select {
   &__form {
     /deep/ .el-form-item {
       margin-bottom: 0;
     }
   }
   &__dialog {
     /deep/ .el-dialog__body {
       padding: 24px 60px;
     }
   }
   &__wrap {
     border: 1px solid #DDDDDD;
     border-radius: 3px;
     margin-bottom: 12px;
   }
   &__setting {
     text-align: center;
     height: 40px;
     line-height: 40px;
     border-right: 1px solid #DDDDDD;
   }
   &__inner {
     /deep/ .el-input__inner {
       border: none;
     }
   }
   &__leftRow {
     display: inline-block;position: absolute;
     width: 36px;
     height: 24px;
     background: #FFFFFF;
     border-radius: 2px;
     border: 1px solid #E2E3E5;
     top: 50%;
     left: 14px;
     text-align: center;
     line-height: 22px;
     cursor: pointer;
     padding: 0;
     font-size: 20px;
     transform: rotate(90deg);
   }
   &__rightRow {
     display: inline-block;
     position: absolute;
     width: 36px;
     height: 24px;
     background: #FFFFFF;
     border-radius: 2px;
     border: 1px solid #E2E3E5;
     top: 50%;
     right: 14px;
     text-align: center;
     line-height: 22px;
     cursor: pointer;
     padding: 0;
     font-size: 20px;
     transform: rotate(-90deg);
   }
 }
</style>
